module.exports = __webpack_public_path__ + "img/Frage1_768x1024.6d8b5afc.jpg";